import React from "react";

import { useHistory } from "react-router-dom";

import { ArrowBackIcon, BlockIcon, Button, IconButton, PageHeaderActions } from "shared/ui";

import { useStopListContext } from "features/StopList/context";
import { FullLabel, ShortLabel } from "features/StopList/styles";

import { Compact, Toolbar, Wide } from "./styles";

const BACK_LABEL = "К позициям меню";

/*
* Действия страницы — в шапке приложения, порталом: узел, отданный в setPageTitle,
* рендерится внутри Header и до контекста фичи не дотягивается.
* Широкий и свёрнутый варианты кнопки «назад» — два узла под медиазапросом, чтобы каждый
* остался обычным примитивом кита.
* */
export const StopListActions = () => {
    const state = useStopListContext();
    const history = useHistory();

    const goToMenu = () => history.push(`/menus/regular/${state.menuId}/view`);

    return (
        <PageHeaderActions>
            <Toolbar>
                <Wide>
                    <Button variant="outlined" color="neutral" onClick={goToMenu}>
                        <ArrowBackIcon />
                        {BACK_LABEL}
                    </Button>
                </Wide>

                <Compact>
                    <IconButton
                        label={BACK_LABEL}
                        size="large"
                        variant="outlined"
                        onClick={goToMenu}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                </Compact>

                <Button variant="contained" onClick={state.openPicker}>
                    <BlockIcon />
                    <FullLabel>Убрать из продажи</FullLabel>
                    <ShortLabel>Убрать</ShortLabel>
                </Button>
            </Toolbar>
        </PageHeaderActions>
    );
};
